import Service from "../../services";

const state = {};

const getters = {};

const actions = {
  saveContact({ commit }, data) {
    return Service.contact.saveContact(data).then((res) => res);
  },
  getImageLanding({ commit }) {
    return Service.contact.getImageLanding().then((res) => res);
  },
};

const mutations = {};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
